// Pure helpers extracted from PerformanceGrade.tsx so the parent
// component (ContractDetailsTab) can compute the same grade and pillar
// scores for the PerformanceGradeDrawer without re-implementing the
// derivation. Lives in its own file so the fast-refresh rule isn't
// broken by exporting non-components alongside the React component.

import {
  computeContractGrade,
  type GradeResult,
  type PillarData,
} from "../../../lib/contract-overview/contractGrade";
import {
  DEFAULT_WATCH_THRESHOLD,
  type ContractPerformanceResult,
  type PillarResult,
} from "../../../lib/contract-overview/contractPerformance";

export function pillarToScore(pillar: PillarResult): number | null {
  // Deliverables / Milestones use onTimePct; KPIs prefer onTrackPct
  // when set (kpisPillar populates both). Falls back to null when
  // neither is available.
  return pillar.onTrackPct ?? pillar.onTimePct ?? null;
}

function asPillarData(pillar: PillarResult): PillarData {
  return {
    score: pillarToScore(pillar),
    sampleSize: pillar.sampleSize,
  };
}

/** Compute the grade letter for a contract performance result. Used by
 *  PerformanceGrade for the dial composition AND by ContractDetailsTab
 *  for the PerformanceGradeDrawer — both consume the same value so the
 *  card surface and the drawer can never disagree. */
export function gradeFromPerformanceResult(
  result: ContractPerformanceResult,
  watchThreshold = DEFAULT_WATCH_THRESHOLD,
  offset = 0,
): GradeResult {
  return computeContractGrade(
    asPillarData(result.deliverables),
    asPillarData(result.milestones),
    asPillarData(result.kpis),
    watchThreshold,
    offset,
  );
}
